import { Suspense } from 'react'
import { Providers } from './app/providers'
import { Toaster } from '@/lib/toast/Toaster'
import { useThemeSync } from '@/lib/theme'

export default function App() {
  useThemeSync()
  return (
    <>
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-bg">
            <div className="w-6 h-6 rounded-full border-2 border-fg-subtle/30 border-t-accent animate-k-spin" />
          </div>
        }
      >
        <Providers />
      </Suspense>
      <Toaster />
    </>
  )
}
